import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  min-height: 300px;
`

function PageEditor({ slug, rawBody, fileRelativePath }) {
  function handleTextChange(e) {
    let data = {
      current: slug,
      pages: {},
    }
    data.pages[slug] = {
      filePath: fileRelativePath,
      updatedAt: new Date().getTime(),
      content: e.target.value,
    }
    parent.postMessage(data, "*")
  }

  return (
    <>
      <TextArea onChange={handleTextChange} defaultValue={rawBody} />
    </>
  )
}

PageEditor.propTypes = {
  fileRelativePath: PropTypes.string,
  rawBody: PropTypes.string,
  slug: PropTypes.string,
}

export default PageEditor
